import { render, staticRenderFns } from "./DepotView.vue?vue&type=template&id=e31798f4&"
import script from "./DepotView.vue?vue&type=script&lang=js&"
export * from "./DepotView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports